/**
 * Encrypt a string using SHA256 (client-side only)
 * @param {string} value - The value to encrypt
 * @returns {Promise<string>} - The SHA256 hash as a hex string
 */
export async function encryptSHA256(value) {
  if (typeof window === 'undefined' || !window.crypto?.subtle) {
    throw new Error('SHA256 encryption requires browser environment')
  }

  try {
    const encoder = new TextEncoder()
    const data = encoder.encode(value)
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', data)
    const hashArray = new Uint8Array(hashBuffer)

    return hashArray.reduce(
      (hex, byte) => hex + byte.toString(16).padStart(2, '0'),
      ''
    )
  } catch (error) {
    throw new Error(
      `Failed to generate SHA-256 hash: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`
    )
  }
}
